import { Navigate } from "react-router-dom";
import { normalizeUserRole } from "@/lib/auth/roles";
import { ContributorView } from "./ContributorView";
import { ModeratorCorrectionView } from "./ModeratorCorrectionView";
import { useGetPaid } from "./useGetPaid";

const GetPaid = () => {
  const ctx = useGetPaid();
  const role = normalizeUserRole(ctx.user?.role);

  if (role === "moderator") {
    // Only the grading page renders this for a moderator; contracts have their own page.
    return <ModeratorCorrectionView ctx={ctx} mode="correction" />;
  }

  if (role === "admin" || role === "super_admin") {
    return <Navigate to={`/${ctx.currentLang}/admin/payments`} replace />;
  }

  if (role === "accountant") {
    return <Navigate to={`/${ctx.currentLang}/accountant/dashboard`} replace />;
  }

  return <ContributorView ctx={ctx} />;
};

export default GetPaid;
